import { useMutation, useQueryClient } from "@tanstack/react-query";
import { materialReqService } from "./api/materialReq";
import { MaterialRequestPayload } from "./types";

export const useCreateMaterialRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ payload }: { payload: MaterialRequestPayload }) => materialReqService.createMaterialReq(payload),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["create-request"] });
    },
  });
};

export const useUpdateMaterialRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: MaterialRequestPayload }) => materialReqService.updateMaterialReq(id, payload),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["update-request"] });
    },
  });
};

export const useGetActivity = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, phaseId }: { projectId: string | undefined; phaseId: string }) =>
      materialReqService.getActivitys(projectId, phaseId),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["get-activity"] });
    },
  });
};

export const useDeleteMaterialRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string }) => materialReqService.deleteMaterialReq(id),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["delete-request"] });
    },
  });
};